import React from 'react'
import s from './index.module.scss'
import classNames from 'classnames'
import { UseFormRegister } from 'react-hook-form'

type RequiredProps = {
	register: UseFormRegister<any>
	name: string
	errors?: any
	bordered?: boolean
	className?: string
	label?: React.ReactNode
}

type OptionalProps = {
	register?: never
	name?: string
	errors?: never
	bordered?: boolean
	className?: string
	label?: React.ReactNode
}

type IProps = React.HTMLProps<HTMLInputElement> & (RequiredProps | OptionalProps)

const Input: React.FC<IProps> = ({ register, name, errors, bordered, className, label, ...props }) => {
	const reg = register && register(name)

	return (
		<label className={classNames(s.wrapper, className)}>
			{label && <span className={s.label}>{label}</span>}

			<input
				type="text"
				{...props}
				{...reg}
				name={name}
				onChange={reg ? reg.onChange : props?.onChange}
				onBlur={reg ? reg.onBlur : props?.onBlur}
				className={classNames(s.input, { [s.bordered]: bordered })}
			/>

			{errors && name && errors[name] && <span className={s.error}>{errors[name]?.message}</span>}
		</label>
	)
}

export default Input
